import React, { useEffect, useCallback } from "react";
import "./organization-edit.scss";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import { getOrgForm } from "../../forms/OrganizationForm";
import { useSelector, useDispatch } from "react-redux";
import {
  selectCurrentOrganization,
  setSelectedOrganization,
  saveOrganization,
  clearNotifications,
  selectOrganizationNotifications,
  selectOrganization,
  getOrganizationAvailableCurrencies,
  selectAvailableCurrencies,
} from "../../reducers/organizationSlice";
import {
  clearUtilityNotifications,
  uploadFile,
  selectCroppedTarget,
  selectUploadedFile,
  selectUtilityNotifications,
  setUploadedFile,
} from "../../reducers/utilitySlice";
import { useNotificationBanner } from "../../hooks/notificationHooks";
import { useFormDataValidation, useImageSelector } from "../../hooks/formHooks";

const OrganizationEdit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedOrganization = useSelector(selectCurrentOrganization);
  const croppedTarget = useSelector(selectCroppedTarget);
  const uploadedFile = useSelector(selectUploadedFile);
  const orgNotifications = useSelector(selectOrganizationNotifications);
  const utilNotifications = useSelector(selectUtilityNotifications);
  const availableCurrencies = useSelector(selectAvailableCurrencies);

  const [context, isValid, setIsValid] = useFormDataValidation({
    initialValue: false,
    data: selectedOrganization,
    setData: setSelectedOrganization,
  });

  const [, , setLogo, removeLogo, , ,] = useImageSelector(
    context,
    "logo",
    25000000
  );

  const loadData = useCallback(() => {
    if (selectedOrganization?.id) {
      dispatch(getOrganizationAvailableCurrencies(selectedOrganization?.id));
    }
  }, [selectedOrganization?.id, dispatch]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    if (croppedTarget?.logo) {
      setIsValid(true);
    }
  }, [croppedTarget?.logo, setIsValid]);

  const saveData = useCallback(
    (uploadedFile) => {
      let newOrg = { ...selectedOrganization };
      newOrg.logo = `${process.env.REACT_APP_GOLFSTATUS_BASE_API_URL}${uploadedFile}`;
      dispatch(saveOrganization(newOrg));
    },
    [dispatch, selectedOrganization]
  );

  useEffect(() => {
    if ((uploadedFile ?? "") !== "") {
      saveData(uploadedFile);
    }
  }, [uploadedFile, saveData]);

  const leftNavigation = () => {
    dispatch(selectOrganization(selectedOrganization.id));
    dispatch(setUploadedFile(""));
    dispatch(clearNotifications());
    dispatch(clearUtilityNotifications());
    navigate(-1);
  };

  context.updateOrganization = (value, property) => {
    setIsValid(true);
    let organization = { ...selectedOrganization };
    organization[property] = value;
    return dispatch(setSelectedOrganization(organization));
  };

  const saveOrg = () => {
    setIsValid(false);
    checkFileUpload();
  };

  const updloadImage = (callback) => {
    const data = croppedTarget.logo;
    return dispatch(uploadFile(data));
  };

  const checkFileUpload = () => {
    let newOrg = { ...selectedOrganization };
    if (
      selectedOrganization?.logo &&
      croppedTarget?.id === selectedOrganization?.id
    ) {
      updloadImage();
    } else {
      dispatch(saveOrganization(newOrg));
    }
  };

  context.validationFailed = () => {
    if (isValid) {
      setIsValid(false);
    }
  };

  //logo
  context.getLogo = () => {
    if (
      selectedOrganization.logo &&
      selectedOrganization.logo !== "/logos/default/missing.png"
    ) {
      return [{ url: selectedOrganization.logo, type: "image" }];
    }
    return [];
  };
  context.setLogo = setLogo;

  context.removeLogo = removeLogo;

  context.updloadImage = (file, callback) => {
    const data = croppedTarget.logo;
    dispatch(uploadFile(data));
  };

  context.editImage = () => {
    navigate("./organization-logo/edit/image");
  };

  const getActions = () => {
    return [
      {
        name: "Save",
        isDisabled: !isValid,
        action: saveOrg,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
  };

  const getNavigation = () => {
    return {
      title: "Organization Details",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
    dispatch(clearUtilityNotifications());
  };

  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "Back to details",
        size: "secondary",
        actionClick: leftNavigation,
      },
    ];
  };

  let notificationSettings = {
    notifications: [...orgNotifications, ...utilNotifications],
    bannerActions: getBannerActions(),
    timeoutAction,
  };

  const [bannerNotifications] = useNotificationBanner(notificationSettings);

  const getContent = () => {
    return (
      <GSForm
        formTitle="Edit Organization"
        formSections={getOrgForm(
          context,
          selectedOrganization,
          availableCurrencies
        )}
      />
    );
  };
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };
  return (
    <organization-edit>
      <GSSidePanelPage
        header={getNavigation()}
        banner={bannerNotifications}
        content={getContent()}
        drawer={getDrawer()}
      />
    </organization-edit>
  );
};

export default OrganizationEdit;
